const i = "Powiadomienie", o = "Powiadomienie krytyczne", t = "Zamknij powiadomienie", c = {
  notification: i,
  criticalNotification: o,
  close: t
};
export {
  t as close,
  o as criticalNotification,
  c as default,
  i as notification
};
